var _Path, _Path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgUsdt = function SvgUsdt(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M10 20c5.522 0 10-4.478 10-10S15.522 0 10 0 0 4.478 0 10c0 5.524 4.478 10 10 10Z",
    fill: "#26A17B"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M11.068 10.924v-.001c-.069.004-.426.026-1.22.026-.636 0-1.081-.018-1.238-.026v.001c-2.442-.107-4.263-.532-4.263-1.042 0-.508 1.823-.933 4.263-1.042v1.66c.16.012.617.04 1.25.04.759 0 1.138-.032 1.208-.04V8.843c2.438.11 4.254.533 4.254 1.042 0 .508-1.82.932-4.254 1.042v-.002Zm0-2.254V7.184h3.4V4.918H5.21v2.266h3.4V8.67c-2.763.126-4.84.673-4.84 1.33 0 .655 2.078 1.202 4.84 1.33v4.762h2.458V11.33c2.76-.127 4.832-.674 4.832-1.33 0-.654-2.074-1.202-4.832-1.329",
    fill: "white"
  })));
};
export default SvgUsdt;